<script>
export default {
  name: "DidoMillesimeDownloadFull",
};
</script>

<script setup>
import { ref } from "vue";
import api from "../../../api";

// define Props
const props = defineProps({
  apiUrl: { type: String, required: true },
  rid: { type: String, required: true },
  millesime: { type: String, required: true },
  infos: { type: Object, required: true },
});

const parquetEnabled = ref(false);
api.withParquet(props.apiUrl).then((result) => (parquetEnabled.value = result));

const downloadLink = (format, geoField = null) => {
  let spec;
  if (format === "csv") {
    spec = {
      format: "csv",
      headers: {
        withColumnName: true,
        withColumnDescription: true,
        withColumnUnit: false,
      },
      sort: [],
      filters: [],
      columns: [],
    };
  }
  if (format === "xlsx") {
    spec = {
      format: "xlsx",
      headers: {
        withColumnName: true,
        withColumnDescription: true,
        withColumnUnit: false,
      },
      sort: [],
      filters: [],
      columns: [],
    };
  }
  if (format === "json") {
    spec = {
      format: "json",
      sort: [],
      filters: [],
      columns: [],
    };
  }
  if (format === "parquet") {
    spec = {
      format: "parquet",
      sort: [],
      filters: [],
      columns: [],
    };
  }
  if (format === "geojson") {
    spec = {
      format: "spatial/geojson",
      geoField,
      sort: [],
      filters: [],
      columns: [],
    };
  }
  return api.getDownloadUrl(props.apiUrl, props.rid, props.millesime, spec);
};
</script>

<template>
  <div>
    <!-- flat files download -->
    <QCard class="q-mt-md" square flat bordered>
      <QCardSection class="q-pa-sm">
        <div class="dido-millesime-title-group-download">
          Formats de fichiers plats
        </div>
      </QCardSection>
      <QCardSection class="q-pa-xs">
        <QList dense>
          <QItem
            clickable
            tag="a"
            :href="downloadLink('csv')"
            target="_blank"
            title="Télécharger le fichier complet au format csv"
          >
            <QItemSection side><QIcon name="mdi-square-small" /></QItemSection>
            <QItemSection>
              <QItemLabel>
                <span>Le fichier complet au format csv</span>
                <QIcon class="on-right" name="mdi-download" />
              </QItemLabel>
            </QItemSection>
          </QItem>
          <QItem
            clickable
            tag="a"
            :href="downloadLink('xlsx')"
            target="_blank"
            title="Télécharger le fichier complet au format xlsx"
          >
            <QItemSection side><QIcon name="mdi-square-small" /></QItemSection>
            <QItemSection>
              <QItemLabel>
                <span>Le fichier complet au format xlsx</span>
                <QIcon class="on-right" name="mdi-download" />
              </QItemLabel>
            </QItemSection>
          </QItem>
          <QItem
            clickable
            tag="a"
            :href="downloadLink('json')"
            target="_blank"
            title="Télécharger le fichier complet au format json"
          >
            <QItemSection side><QIcon name="mdi-square-small" /></QItemSection>
            <QItemSection>
              <QItemLabel>
                <span>Le fichier complet au format json</span>
                <QIcon class="on-right" name="mdi-download" />
              </QItemLabel>
            </QItemSection>
          </QItem>
          <QItem
            v-if="parquetEnabled"
            clickable
            tag="a"
            :href="downloadLink('parquet')"
            target="_blank"
            title="Télécharger le fichier complet au format parquet"
          >
            <QItemSection side><QIcon name="mdi-square-small" /></QItemSection>
            <QItemSection>
              <QItemLabel>
                <span>Le fichier complet au format parquet</span>
                <QIcon class="on-right" name="mdi-download" />
              </QItemLabel>
            </QItemSection>
          </QItem>
        </QList>
      </QCardSection>
    </QCard>
    <!-- spatial files download -->
    <QCard
      v-if="props.infos.geoFields.length"
      class="q-mt-md"
      square
      flat
      bordered
    >
      <QCardSection class="q-pa-sm">
        <div class="dido-millesime-title-group-download">
          Formats de fichiers géographiques
        </div>
      </QCardSection>
      <QCardSection class="q-pa-xs">
        <QList dense>
          <QItem
            v-for="(geoField, index) in props.infos.geoFields"
            :key="index"
            clickable
            tag="a"
            :href="downloadLink('geojson', geoField)"
            target="_blank"
            :title="`Télécharger le fichier au format geojson (ref ${geoField})`"
          >
            <QItemSection side><QIcon name="mdi-square-small" /></QItemSection>
            <QItemSection>
              <QItemLabel>
                <span
                  >Le fichier complet au format geojson (ref
                  {{ geoField }})</span
                >
                <QIcon class="on-right" name="mdi-download" />
              </QItemLabel>
            </QItemSection>
          </QItem>
        </QList>
      </QCardSection>
    </QCard>
  </div>
</template>

<style lang="sass" scoped>
.dido-millesime-title-group-download
  font-weight: 600
  font-size: 1.2em
</style>
